import { BrowserRouter } from 'react-router-dom';
import { HOMEPAGE } from './constants/routes.constants';
import { Routes } from './routes';

import '@ctn/ui/components/ctn-styles/styles.scss';
import './assets/themes/theme.scss';
import './styles/styles.scss';
import { Layout } from './containers';

function App() {
	return (
		<BrowserRouter basename={HOMEPAGE}>
			<Layout>
				<Routes />
			</Layout>
		</BrowserRouter>
	);
}

export default App;
